export default __webpack_public_path__ + "36d9f6d3cd0db477732de47af28d97fa.png";